import {
  Alert,
  Text,
  Button,
  Stack,
  Group,
  Table,
  CopyButton,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconCircleCheck, IconCopy } from '@tabler/icons-react';
import { useIntl } from 'react-intl';
import routes from '@commons/routes';
import { Folder as FolderType } from '@/users/components/UserFolders/types';
import { isCreatedWithinLast24Hours } from '@/commons/isCreatedWithinLast24Hours';

export const NewFilesAdded = ({ folder }: { folder: FolderType }) => {
  const intl = useIntl();

  const handleCopy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      notifications.show({
        title: intl.formatMessage({ id: 'copiedToClipboard' }),
        message: '',
        color: 'green',
        autoClose: 2000,
      });
    } catch (err) {
      notifications.show({
        title: 'Failed to copy',
        message: '',
        color: 'red',
        autoClose: 2000,
      });
    }
  };

  return (
    folder?.files?.length >= 1 &&
    folder?.files?.some((_file: any) =>
      isCreatedWithinLast24Hours(_file.createdAt)
    ) && (
      <Stack gap="md">
        <Alert variant="light" color="green" icon={<IconCircleCheck />}>
          <Stack gap="md">
            <Text fz="sm">
              {intl.formatMessage({
                id: 'pleaseNoteTheAccessDataBelowToAccessThemLater',
              })}
              .
            </Text>
          </Stack>
        </Alert>

        <Table
          variant="vertical"
          layout="fixed"
          striped
          highlightOnHover
          withTableBorder
          withColumnBorders
        >
          <Table.Tbody>
            <Table.Tr>
              <Table.Th w={90}>{intl.formatMessage({ id: 'id' })}</Table.Th>
              <Table.Td>{folder?.folderName}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th w={90}>{intl.formatMessage({ id: 'link' })}</Table.Th>
              <Table.Td
                onClick={() =>
                  handleCopy(
                    `${window.location.origin}${routes.routes.clientFolder(folder?.folderName)}`
                  )
                }
                style={{
                  wordBreak: 'break-all',
                  overflowWrap: 'break-word',
                  whiteSpace: 'normal',
                  cursor: 'pointer',
                }}
              >
                {`${window.location.origin}${routes.routes.clientFolder(folder?.folderName)}`}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th w={90}>
                {intl.formatMessage({ id: 'password' })}
              </Table.Th>
              <Table.Td onClick={() => handleCopy(folder?.password)}>
                {folder?.password}
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>

        <Group justify="center">
          <CopyButton
            value={`${window.location.origin}${routes.routes.clientFolder(folder.folderName)}\n${intl.formatMessage({ id: 'password' })}: ${folder?.password}`}
          >
            {({ copied, copy }) => (
              <Button
                variant="light"
                leftSection={
                  copied ? <IconCheck size={16} /> : <IconCopy size={16} />
                }
                color={copied ? 'green' : 'blue'}
                onClick={copy}
              >
                {copied
                  ? intl.formatMessage({ id: 'copiedToClipboard' })
                  : intl.formatMessage({ id: 'copy' })}
              </Button>
            )}
          </CopyButton>
        </Group>
      </Stack>
    )
  );
};
